import api from "@/lib/api";
import { toast } from "sonner";
import { showPaywall } from "@/lib/paywall";

// Charge a prepared entry (1 credit, idempotent per rodeo — re-preparing is free).
// Returns { ok: true } when the entry summary may be shown (free trial / plan-included /
// already prepared / credit spent), or { ok: false } on the paywall (toast shown here).
export async function prepareEntry(rodeoId) {
  try {
    const { data } = await api.post(`/rodeos/${rodeoId}/prepare-entry`);
    if (data?.charged) toast.success(`Entry prepared · ${data.charged} credit used`);
    window.dispatchEvent(new Event("rp-credits-refresh"));
    return { ok: true };
  } catch (e) {
    const d = e?.response?.data?.detail;
    if (e?.response?.status === 402 && d) {
      showPaywall({ ...d, feature: "prepared entry" });
      return { ok: false };
    }
    return { ok: true };
  }
}
